import React, { useEffect, useState } from 'react';

const CriteriaTemplate = ({ factorData, setAnswerFactor, currentAnswer, setSubPageInComplete }) => {
    const { factor, description, weight, grading, text_evaluations, checklist_evaluations } = factorData;
    const key = currentAnswer.key;

    const [rating, setRating] = useState(null);
    const [textInputs, setTextInputs] = useState(
        Object.fromEntries(
            (text_evaluations || []).map(te => [te.id, ''])
        )
    );

    const [checklistInputs, setChecklistInputs] = useState(
        Object.fromEntries(
            (checklist_evaluations || []).flatMap(category =>
                category.items.map(item => [item.id, false])
            )
        )
    );

    useEffect(() => {
        if (!currentAnswer?.data) return;

        setRating(currentAnswer.data.grade ?? null);

        setTextInputs(
            currentAnswer.data.text ??
            Object.fromEntries(
                (text_evaluations || []).map(te => [te.id, ''])
            )
        );

        setChecklistInputs(
            currentAnswer.data.checklist ??
            Object.fromEntries(
                (checklist_evaluations || []).flatMap(category =>
                    category.items.map(item => [item.id, false])
                )
            )
        );

    }, [currentAnswer]);

    // Validate input fields and trigger error state
    useEffect(() => {
        const isGradeInvalid = rating === null || rating === '';
        const isAnyTextInvalid = Object.values(textInputs).some(v => v === null || v.trim() === '');
        setSubPageInComplete(false);
        // setSubPageInComplete(false);
        // if (isGradeInvalid || isAnyTextInvalid) {
        //     setSubPageInComplete(true);
        // } else {
        //     setSubPageInComplete(false);
        // }
    }, [rating, textInputs]);

    const updateAnswer = (newRating, newInputs, newChecklistInputs) => {
        const updatedEntry = {
            key,
            data: {
                grade: newRating,
                text: {
                    ...newInputs
                },
                checklist: {
                    ...newChecklistInputs
                }
            }
        };

        setAnswerFactor(prev => ({
            ...prev,
            factors: prev.factors.map(entry =>
                entry.key === key
                    ? updatedEntry
                    : entry
            )
        }));
    };;

    const handleRatingChange = (value) => {
        setRating(value);
        updateAnswer(value, textInputs, checklistInputs);
    };

    const handleTextChange = (id, value) => {
        const updatedInputs = {
            ...textInputs,
            [id]: value
        };
        setTextInputs(updatedInputs);
        updateAnswer(rating, updatedInputs, checklistInputs);
    };

    const handleChecklistChange = (id, checked) => {
        const updatedChecklistInputs = {
            ...checklistInputs,
            [id]: checked
        };

        setChecklistInputs(updatedChecklistInputs);

        updateAnswer(
            rating,
            textInputs,
            updatedChecklistInputs
        );
    };

    return (
        <div className="evaluation-criteria mb-5">
            <div className="rating-header d-flex align-items-center justify-content-between">
                <span className="category-label label-semibold">{factor}</span>
                <div className="rating-scale d-flex align-items-center my-2">
                    <span className="progress-badge me-2">{weight}%</span>
                    {grading.map(({ value }) => (
                        <button
                            key={value}
                            className={`rating-btn label-semibold ${value === rating ? 'selected' : ''}`}
                            onClick={() => handleRatingChange(value)}
                        >
                            {value}
                        </button>
                    ))}
                </div>
            </div>

            <div className="rating-description text-end mb-1">
                {grading.map(({ value, note }) => (
                    <span key={value} className={`rating-label mx-2 ${value === rating ? 'selected' : ''}`}>
                        <span className='label-bold'>{value}</span> – {note}
                    </span>
                ))}
            </div>
            <div className="textarea-wrapper text-13">
                <label className='label-semibold text-13'>Description</label>
                <textarea
                    className="form-control desc text-13"
                    value={description}
                    readOnly
                />
            </div>

            {(checklist_evaluations || []).map((category) => (
                <div
                    className="checklist-wrapper mt-3"
                    key={category.category}
                >
                    <label className='label-semibold text-13 d-block mb-2'>
                        {category.category}
                    </label>

                    {category.items.map((item) => {
                        const keyLabel =
                            item.label
                                .toLowerCase()
                                .replace(/\s/g, '_');

                        return (
                            <div
                                key={item.label}
                                className="d-flex align-items-center mb-2"
                            >
                                <input
                                    type="checkbox"
                                    className="form-check-input me-2"
                                    id={keyLabel}
                                    checked={checklistInputs?.[item.id] ?? false}
                                    onChange={(e) =>
                                        handleChecklistChange(
                                            item.id,
                                            e.target.checked
                                        )
                                    }
                                    disabled={rating === null}
                                />

                                <label
                                    className="form-check-label "
                                    htmlFor={keyLabel}
                                >
                                    {item.label}
                                </label>
                            </div>
                        );
                    })}
                </div>
            ))}

            {text_evaluations?.map(({ id, label, max_chars }) => (
                <div className="textarea-wrapper mb-2 text-13" key={id}>
                    <label className='label-semibold mb-1 text-13'>{label}</label>

                    <textarea
                        className="form-control text-13"
                        maxLength={max_chars}
                        value={textInputs?.[id] ?? ''}
                        onChange={(e) => handleTextChange(id, e.target.value)}
                        disabled={rating === null}
                        title={rating === null ? 'Please select a grading first' : ''}
                    />
                </div>
            ))}
        </div>
    );
};

export default CriteriaTemplate;
